const comments = [
  {
    id: 1,
    name: '吃瓜群众老王',
    avatar: '王',
    time: '2小时前',
    content: '这个站太强了，暗网吃瓜的视频更新速度真的快，每天都有新料，比我自己到处找方便多了。51吃瓜在线资源很全！',
    source: '来自 #51吃瓜在线',
  },
  {
    id: 2,
    name: '深夜追瓜人',
    avatar: '追',
    time: '5小时前',
    content: '51暗网吃瓜的直播频道画质真不错，高清流畅不卡顿，半夜追瓜的最佳选择。51cg吃瓜的内容也很劲爆。',
    source: '来自 #暗网吃瓜直播',
  },
  {
    id: 3,
    name: '八卦小能手',
    avatar: '八',
    time: '8小时前',
    content: '朋友推荐来的，果然没让我失望。吃瓜视频种类齐全，从娱乐八卦到社会热点都有，每天都在这里蹲更新。',
    source: '来自 #吃瓜视频',
  },
  {
    id: 4,
    name: '匿名吃瓜人',
    avatar: '匿',
    time: '12小时前',
    content: '作为一个资深吃瓜爱好者，这个平台真的满足了我所有的需求。在线暗网吃瓜体验一流，界面干净没广告干扰。',
    source: '来自 #51暗网吃瓜',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            吃瓜群众热评
          </h2>
          <p className="text-sm text-foreground-500 mt-3">看看大家都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-accent-700">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{comment.content}</p>
              <p className="text-xs text-accent-600 mt-3 pt-3 border-t border-background-200/70">{comment.source}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}